import React from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';
import { formattedNumber } from 'atc-js';

import {
    Panel,
} from 'reaxl';

const getCount = (count) => 'Shop ' + formattedNumber({ value: count }) + (count === 1 ? ' Car' : ' Cars');

function RecentSearchCard({ data, fullHeight = false, className, ...rest }) {

    const classname = clsx({
        'display-flex flex-grow flex-column justify-content-between': fullHeight,
    }, 'recent-search-card cursor-pointer', className);

    const countLabel = data.totalCount ? getCount(data.totalCount) : 'Shop Cars';

    return (
        <Panel
            data-cmp="recentSearchCard"
            className={classname}
            {...rest}
        >
            <Panel.Body>
                <div
                    title={data.fullHeading}
                    className="text-bold text-size-500 text-gray-base"
                >
                    {data.heading}
                </div>
                <div
                    title={data.fullSubHeading}
                    className="text-size-300 text-normal text-subdued-lighter"
                >
                    {data.subHeading}
                </div>
            </Panel.Body>
            <Panel.Footer className="bg-neutral-primary">
                <div className="text-link">
                    {countLabel}
                </div>
            </Panel.Footer>
        </Panel>
    );
}

RecentSearchCard.propTypes /* remove-proptypes */ = {
    /**
     * data object for recent search card
     */
    data: PropTypes.shape({
        /**
         * url for Shop Car link
         */
        url: PropTypes.string,
        /**
         * number of SRP results to display
         */
        totalCount: PropTypes.number,
        /**
         * truncated heading
         */
        heading: PropTypes.string,
        /**
         * full heading to be placed in title attr
         */
        fullHeading: PropTypes.string,
        /**
         * truncated subheading (description)
         */
        subHeading: PropTypes.string,
        /**
         * full subheading to be placed in title attr
         */
        fullSubHeading: PropTypes.string,
    }).isRequired,
    /**
     * if true, card will stretch to take 100% height
     */
    fullHeight: PropTypes.bool,
    /**
     * className to be passed to the root node
     */
    className: PropTypes.string,
};

export default RecentSearchCard;
